export const TaskStatus = {
  DRAFT: 'Draft',
  PLANNED: 'Planned',
  IN_PROGRESS: 'In Progress',
  WAITING_ON_EXTERNAL: 'Waiting on External',
  BLOCKED: 'Blocked',
  UNDER_REVIEW: 'Under Review',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};

export const WORK_STARTED_STATUSES = [
  TaskStatus.IN_PROGRESS,
  TaskStatus.WAITING_ON_EXTERNAL,
  TaskStatus.BLOCKED,
  TaskStatus.UNDER_REVIEW
];

export const statusOptions = Object.values(TaskStatus).map((status) => ({
  label: status,
  value: status
}));

export const editableStatusOptions = statusOptions.filter(
  (option) =>
    option.value !== TaskStatus.COMPLETED &&
    option.value !== TaskStatus.CANCELLED &&
    option.value !== TaskStatus.UNDER_REVIEW
);

export function statusOptionsForEdit(current) {
  if (!current || editableStatusOptions.some((o) => o.value === current)) {
    return editableStatusOptions;
  }
  return [{ label: current, value: current }, ...editableStatusOptions];
}

export function isWorkStarted(status) {
  return WORK_STARTED_STATUSES.includes(status);
}

export function toDateOnly(value) {
  if (!value) return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
}

export function statusChipClass(status) {
  switch (status) {
    case TaskStatus.COMPLETED:
      return 'bg-green-100 text-green-700';
    case TaskStatus.PLANNED:
    case TaskStatus.DRAFT:
      return 'bg-yellow-100 text-yellow-700';
    case TaskStatus.IN_PROGRESS:
    case TaskStatus.UNDER_REVIEW:
      return 'bg-blue-100 text-blue-700';
    case TaskStatus.WAITING_ON_EXTERNAL:
      return 'bg-purple-100 text-purple-700';
    case TaskStatus.BLOCKED:
    case TaskStatus.CANCELLED:
      return 'bg-gray-200 text-gray-700';
    case 'Rejected':
      return 'bg-rose-50 text-rose-700';
    default:
      return 'bg-gray-100 text-gray-600';
  }
}
